import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import { INotificationDelegate } from '../../../../global/helpers/notification_delegate';
import { ApStudentDetailsModel } from '../models/ap_student_details_model';

angular.module('capability-ng-academic-planner').factory(
  'loadAdvisorStudentDetailsCommand',
  (
    ngApStudentDetailsModel: ApStudentDetailsModel,
    $http: ng.IHttpService,
    defineCommand: IDefineCommand,
    log: any,
    ngAPNotificationDelegate: INotificationDelegate
  ): ICommand =>
    defineCommand('loadAdvisorStudentDetailsCommand', (deferred: ng.IDeferred<IQuery[]>, studentNk: string = '') =>
      $http
        .get('/cat/student/profile/', {
          params: {
            'student-id': studentNk
          }
        })
        .then((response: any) => ngApStudentDetailsModel.clear().write(response.data.student))
        .catch((e) => {
          ngAPNotificationDelegate.error(`Unable to get student details: ${e.data.detail}`);
          log.error(e);
          deferred.reject(e.data);
        })
    )
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/student_details/commands/ap_load_student_details_command.ts